import { COMMISSIONS_POLICIES_DELETE_OPPORTUNITY_ROW } from '../constants'

export function reducer(state, action) {
  if (action.type === COMMISSIONS_POLICIES_DELETE_OPPORTUNITY_ROW) {
      return {
        ...state,
        policies: {
          ...state.policies,
          opportunityIncentiveProduct: action.data.opportunityIncentiveProduct
        }
      }
    }
    else {
      return state
    }
}
